import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCoreweaveMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "24.69 30.19 142.86 86",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M80.37 94.96H59.71c-1.26 0-2.52-.79-3.28-2.1l-9.57-17.83c-.5-1.31-.5-2.62 0-3.67l9.57-17.83c.76-1.31 2.02-2.1 3.28-2.1h11.84c1.26 0 2.52-.79 3.28-2.1l8.57-16c.76-1.31-.25-2.88-1.51-2.88H50.14c-2.77 0-5.04 1.57-6.55 3.93l-18.9 35.14a8.113 8.113 0 0 0 0 7.6L43.59 112a7.47 7.47 0 0 0 6.55 3.93h40.57c1.51 0 2.27-1.57 1.51-2.88L83.4 96.79c-.25-1.31-1.51-1.84-3.02-1.84Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m136.31 45.92-8.06-14.16c-.76-1.31-2.52-1.31-3.28 0L90.95 94.69c-.5 1.31-.5 2.62 0 3.67l8.82 16.52c.76 1.31 2.52 1.31 3.28 0l33.26-61.36a8.113 8.113 0 0 0 0-7.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m95.24 74.77 10.08-18.62c.5-1.05.5-2.62 0-3.93L93.73 31.5c-.76-1.31-2.52-1.31-3.28 0l-9.83 18.09c-.5 1.05-.5 2.62 0 3.67L91.96 74.5c.76 1.57 2.77 1.57 3.28.26Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m166.04 45.92-8.06-14.16c-.76-1.31-2.52-1.31-3.28 0l-34.02 62.93c-.5 1.31-.5 2.62 0 3.67l9.07 16.52c.76 1.31 2.52 1.31 3.28 0l33.26-61.36c1.26-2.36 1.26-5.24-.25-7.6Z"
		})
	]
});
export { SvgIconCoreweaveMark as ReactComponent };
